import * as React from 'react';
import { TableCell, TableRow } from '@telia-front/table';
import NameCell from './name-cell';
import { cellBEM, usePlaceholderArray } from './utils';
const NameRow = (props) => {
    const { items, deviceLabel, renderButton, isMobile, cellWidth, isDisabled } = props;
    const placeholders = usePlaceholderArray(items.length);
    return (React.createElement(TableRow, { className: "product-comparison__table-row" },
        React.createElement(TableCell, { width: 3, type: "th", className: cellBEM(undefined, isMobile), valign: "top", scope: "row" }, deviceLabel),
        items.map((item, index) => {
            return (React.createElement(NameCell, { isMobile: false, item: item, key: index, deviceLabel: deviceLabel, renderButton: renderButton, width: cellWidth, isDisabled: isDisabled }));
        }),
        placeholders.map((_i, index) => {
            return React.createElement(TableCell, { className: cellBEM(), width: cellWidth, key: `placeholder-${index}`, valign: "top" });
        })));
};
export default NameRow;
